export const CabinetSlot = {
  flow: 'y',
  gap: 'X',
  padding: 'Z',
  round: 'Y',
  minHeight: 'B1',
  cursor: 'pointer',
  transition: 'all 0.15s ease',
  ':hover': { opacity: '0.85', transform: 'scale(1.01)' },

  background: (el, s) => {
    const st = s.status
    if (st === 'occupied') return 'blue.15'
    if (st === 'cleaning') return 'amber.15'
    if (st === 'maintenance') return 'red.15'
    return 'teal.15'
  },

  borderLeft: (el, s) => {
    const st = s.status
    if (st === 'occupied') return '3px solid blue'
    if (st === 'cleaning') return '3px solid amber'
    if (st === 'maintenance') return '3px solid red'
    return '3px solid teal'
  },

  onClick: (e, el, s) => {
    s.root.update({
      selectedSlot: {
        cabinet: s.cabinetName || '',
        time: s.time || '',
        status: s.status || 'available',
        doctor: s.doctor || '',
        patient: s.patient || '',
        procedure: s.procedure || ''
      }
    })
  },

  TimeLabel: {
    text: (el, s) => s.time || '',
    fontSize: 'Y',
    fontWeight: '700',
    color: 'inkText'
  },

  DoctorName: {
    text: (el, s) => s.doctor || '',
    fontSize: 'Y',
    color: 'inkMuted',
    fontStyle: 'italic',
    show: (el, s) => s.status === 'occupied'
  },

  PatientName: {
    text: (el, s) => s.patient || '',
    fontSize: 'Z',
    fontWeight: '600',
    color: 'inkText',
    show: (el, s) => s.status === 'occupied'
  },

  ProcedureType: {
    text: (el, s) => s.procedure || '',
    fontSize: 'Y',
    color: 'inkMuted',
    show: (el, s) => s.status === 'occupied'
  },

  StatusLabel: {
    fontSize: 'Y',
    fontWeight: '600',
    show: (el, s) => s.status !== 'occupied',
    text: (el, s) => {
      const st = s.status
      if (st === 'cleaning') return '{{ cleaning | polyglot }}'
      if (st === 'maintenance') return '{{ maintenance | polyglot }}'
      return '{{ available | polyglot }}'
    },
    color: (el, s) => {
      const st = s.status
      if (st === 'cleaning') return 'amber'
      if (st === 'maintenance') return 'red'
      return 'teal'
    }
  }
}
